import * as React from 'react'
import {startsWith} from 'lodash'
import {SlotBlock} from '../components/dynamic/SlotBlock'
import {PaymentPurposesBlock} from '../components/widgets/payment-form/blocks/PaymentPurposesBlock'
import {PaymentAmountsAndIntervalsBlock} from '../components/widgets/payment-form/blocks/PaymentAmountsAndIntervalsBlock'
import {PaymentPaymentMethodsBlock} from '../components/widgets/payment-form/blocks/PaymentPaymentMethodsBlock'
import {PaymentProfileBlock} from '../components/widgets/payment-form/blocks/PaymentProfileBlock'
import {PaymentProfileShortBlock} from '../components/widgets/payment-form/blocks/PaymentProfileShortBlock'
import {PaymentAddressBlock} from '../components/widgets/payment-form/blocks/PaymentAddressBlock'
import {PaymentCoverFeeBlock} from '../components/widgets/payment-form/blocks/PaymentCoverFeeBlock'

///////////////////////////////////////////////////////////////////////////////

export type BlockProps = {
  position?: number
}

type Blocks = {
  [key in Block]: (props: BlockProps) => JSX.Element
}

///////////////////////////////////////////////////////////////////////////////

export enum Block {
  // generic blocks
  SLOT_BLOCK = 'slot_block',

  // payment blocks
  PAYMENT_PURPOSES = 'payment_purposes',
  PAYMENT_AMOUNTS_AND_INTERVALS = 'payment_amounts_and_intervals',
  PAYMENT_PAYMENT_METHODS = 'payment_payment_methods',
  PAYMENT_PROFILE = 'payment_profile',
  PAYMENT_PROFILE_SHORT = 'payment_profile_short',
  PAYMENT_ADDRESS = 'payment_address',
  PAYMENT_COVER_FEE = 'payment_cover_fee',
}

///////////////////////////////////////////////////////////////////////////////

const blocks: Blocks = {
  [Block.SLOT_BLOCK]: (props: BlockProps) => <SlotBlock {...props} />,

  [Block.PAYMENT_AMOUNTS_AND_INTERVALS]: (props: BlockProps) => (
    <PaymentAmountsAndIntervalsBlock {...props} />
  ),
  [Block.PAYMENT_PURPOSES]: (props: BlockProps) => (
    <PaymentPurposesBlock {...props} />
  ),
  [Block.PAYMENT_PAYMENT_METHODS]: (props: BlockProps) => (
    <PaymentPaymentMethodsBlock {...props} />
  ),
  [Block.PAYMENT_PROFILE]: (props: BlockProps) => (
    <PaymentProfileBlock {...props} />
  ),
  [Block.PAYMENT_PROFILE_SHORT]: (props: BlockProps) => (
    <PaymentProfileShortBlock {...props} />
  ),
  [Block.PAYMENT_ADDRESS]: (props: BlockProps) => (
    <PaymentAddressBlock {...props} />
  ),
  [Block.PAYMENT_COVER_FEE]: (props: BlockProps) => (
    <PaymentCoverFeeBlock {...props} />
  ),
}

export const getBlock = (name: Block) => {
  // this is a dynamic slot
  if (startsWith(name, 'slot_')) {
    return (props: BlockProps) => {
      return blocks[Block.SLOT_BLOCK]({...props, slotName: name} as any)
    }
  }

  if (blocks[name]) {
    return blocks[name]
  }

  throw new Error('Could not find block "' + name + '"')
}
